/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PalReauthSubmissionDocument } from './PalReauthSubmissionDocument';
import {
    PalReauthSubmissionDocumentFromJSON,
    PalReauthSubmissionDocumentFromJSONTyped,
    PalReauthSubmissionDocumentToJSON,
    PalReauthSubmissionDocumentToJSONTyped,
} from './PalReauthSubmissionDocument';
import type { PalReauthDocumentSource } from './PalReauthDocumentSource';
import {
    PalReauthDocumentSourceFromJSON,
    PalReauthDocumentSourceFromJSONTyped,
    PalReauthDocumentSourceToJSON,
    PalReauthDocumentSourceToJSONTyped,
} from './PalReauthDocumentSource';

/**
 * 
 * @export
 * @interface PalReauthSubmissionDocumentSection
 */
export interface PalReauthSubmissionDocumentSection {
    /**
     * The Net Health document type or the PointClickCare MDR document type the section groups.
     */
    key: string;
    /**
     * 
     */
    label: string;
    /**
     * 
     */
    source: PalReauthDocumentSource;
    /**
     * 
     */
    is_selectable: boolean;
    /**
     * 
     */
    documents: Array<PalReauthSubmissionDocument>;
}



/**
 * Check if a given object implements the PalReauthSubmissionDocumentSection interface.
 */
export function instanceOfPalReauthSubmissionDocumentSection(value: object): value is PalReauthSubmissionDocumentSection {
    if (!('key' in value) || value['key'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('source' in value) || value['source'] === undefined) return false;
    if (!('is_selectable' in value) || value['is_selectable'] === undefined) return false;
    if (!('documents' in value) || value['documents'] === undefined) return false;
    return true;
}

export function PalReauthSubmissionDocumentSectionFromJSON(json: any): PalReauthSubmissionDocumentSection {
    return PalReauthSubmissionDocumentSectionFromJSONTyped(json, false);
}

export function PalReauthSubmissionDocumentSectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalReauthSubmissionDocumentSection {
    if (json == null) {
        return json;
    }
    return {
        
        'key': json['key'],
        'label': json['label'],
        'source': PalReauthDocumentSourceFromJSON(json['source']),
        'is_selectable': json['is_selectable'],
        'documents': ((json['documents'] as Array<any>).map(PalReauthSubmissionDocumentFromJSON)),
    };
}

export function PalReauthSubmissionDocumentSectionToJSON(json: any): PalReauthSubmissionDocumentSection {
    return PalReauthSubmissionDocumentSectionToJSONTyped(json, false);
}

export function PalReauthSubmissionDocumentSectionToJSONTyped(value?: PalReauthSubmissionDocumentSection | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'key': value['key'],
        'label': value['label'],
        'source': PalReauthDocumentSourceToJSON(value['source']),
        'is_selectable': value['is_selectable'],
        'documents': ((value['documents'] as Array<any>).map(PalReauthSubmissionDocumentToJSON)),
    };
}

